import React, { useState, useEffect } from "react";
import { Header, Dropdown, TextArea, List, Avatar, Input, Button, RadioGroup, Checkbox, AddIcon } from "@fluentui/react-northstar";
import { useIntl } from 'react-intl';
const ServiceIntegrationComponent = (props) => {
    const intl = useIntl();
    const [crmDataErrorMessage, setCrmDataErrorMessage] = useState(false)
    const [crmBodyText, setCrmBodyText] = useState(
        props.queueInfos?.integrationParams?.crmDataSync?.body
          ? JSON.stringify(props.queueInfos.integrationParams.crmDataSync.body, null, 2)
          : ""
      );
    const inputItems = [
        {
            key: "none",
            header: intl.formatMessage({ id: "NONE" })
        },
        {
            key: "webHook",
            header: intl.formatMessage({ id: "WEB_HOOK" })

        },
        {
            key: "CRM",
            header: intl.formatMessage({ id: "CRM" })

        },
        {
            key: "inAgentConsole",
            header: intl.formatMessage({ id: "IN_AGENT_CONSOLE" })
        },
        {
            key: "openNewBrowserTab",
            header: intl.formatMessage({ id: "OPEN_NEW_BROWSER_TAB" })
        }
    ]
    useEffect(() => {

        let url = props.queueInfos.integrationParams.serviceURL;
        if (url !== '') {

            props.queueInfos.integrationParams.serviceParameters.map(function (item, i) {
                if (item.paramName !== '' && item.value !== '') {
                    if (i === 0) {
                        url = url + '?' + item.paramName + '=' + item.value
                    } else {
                        url = url + '&' + item.paramName + '=' + item.value
                    }
                    props.setServiceResultUrl(url)
                }

            })
        }
    }, [props.queueInfos.integrationParams.serviceParameters])
    useEffect(() => {
        if (typeof props.queueInfos?.integrationParams?.crmDataSync?.body === 'object') {
          const stringified = JSON.stringify(props.queueInfos.integrationParams.crmDataSync.body, null, 2);
          setCrmBodyText(stringified);
          setCrmDataErrorMessage(false);
        }
      }, [props.queueInfos?.integrationParams?.crmDataSync?.body]);
    return (
        <div className="form-container ">
            <Header as="h2" content={intl.formatMessage({ id: "DISPLAY" })} className="label-integration" />
            <div style={{ marginLeft: '50px' }}>
                {
                    props.queueInfos?.integrationParams?.resultServiceURL !== undefined && props.queueInfos?.integrationParams?.resultServiceURL !== '' ?
                        <div
                            className="alert alert-success "
                            style={{
                                width: '440px',
                                position: 'fixed',
                                right: '168px',
                                top: '98px',
                            }}
                        >
                            <p>{props.queueInfos?.integrationParams?.resultServiceURL}</p>
                        </div>
                        :
                        null
                }
                <Header as="h4" content={intl.formatMessage({ id: "type" })} className="label-integration" />
                <Dropdown
                    className="from-item"
                    items={inputItems}
                    placeholder={intl.formatMessage({ id: "select-type" })}
                    value={
                        inputItems.filter(item => item.key === props.queueInfos?.integrationParams?.servicetype).length > 0 &&
                            inputItems.filter(item => item.key === props.queueInfos?.integrationParams?.servicetype)[0].header ?
                            inputItems.filter(item => item.key === props.queueInfos?.integrationParams?.servicetype)[0].header :
                            intl.formatMessage({ id: "NONE" })
                    }
                    checkable
                    onChange={(e, data) => {
                        props.setServicetype(data.value.key)
                    }}
                    getA11ySelectionMessage={{
                        onAdd: item => `${item} has been selected.`,
                    }}
                />

                {

                    props.queueInfos && props.queueInfos.integrationParams && props.queueInfos.integrationParams.
                        servicetype && props.queueInfos.integrationParams.servicetype === "CRM" ?
                        <>
                            <Header as="h4" content={intl.formatMessage({ id: "CRM_NAME" })} className="label-integration" />
                            <Input
                                value={props.queueInfos?.integrationParams?.CRMName}
                                className="from-item"
                                onChange={(e, data) => {
                                    props.setServiceCRMName(data.value)
                                }}
                            />
                        </>
                        :
                        null
                }

                <Header as="h4" content="URL" className="label-integration" />
                <Input
                    className="from-item"
                    value={props.queueInfos?.integrationParams?.serviceURL}
                    onChange={(e, data) => {
                        props.setServiceURL(data.value)
                    }}
                />

            </div>
            <Header as="h2" content={intl.formatMessage({ id: "PUSH_DATA_TO_CRM" })} className="label-integration" />
            <div style={{ marginLeft: '50px' }}>

                <Header as="h4" content={intl.formatMessage({ id: "SYNC_URL" })} className="label-integration" />
                <Input
                    className="from-item"
                    value={props.queueInfos?.integrationParams?.crmDataSync?.syncUrl}
                    onChange={(e, data) => {
                        props.setSyncURL(data.value)
                    }}
                />
                <Header as="h4" content={intl.formatMessage({ id: "Body" })} className="label-integration" />
                <TextArea
                    value={crmBodyText}
                    style={{ marginLeft: "50px" }}
                    resize="both"
                    className="from-item"
                    onChange={(e, data) => {
                        setCrmBodyText(data.value);
                        try {
                            const parsed = JSON.parse(data.value);
                            props.setCrmDataSync(parsed); // Only update when valid
                            setCrmDataErrorMessage(false);
                        } catch (err) {
                            setCrmDataErrorMessage(true); // Don't update state with invalid JSON
                        }
                    }}
                />
                {
                    crmDataErrorMessage ?
                        <p style={{ color: 'red',marginLeft:'50px',marginTop:'3px' }}>{intl.formatMessage({ id: "ERROR_SAVE_CRMDATA_SYNC" })}</p>
                        :
                        null
                }

            </div>

        </div>
    )
}
export default ServiceIntegrationComponent;